declare let window: Window & {
  VUE_APP_API: string;
  VUE_APP_KEYCLOAK_URL: string;
  VUE_APP_KEYCLOAK_REALM: string;
  VUE_APP_KEYCLOAK_CLIENT_ID: string;
  VUE_APP_TENANT_ID: string;
  VUE_APP_RECAPTCHA_KEY: string;
  VUE_APP_COMPANY_NAME: string;
};

export default {
  tenantId: window["VUE_APP_TENANT_ID"] || process.env.VUE_APP_TENANT_ID,
  appApi: window["VUE_APP_API"] || process.env.VUE_APP_API,
  keycloakUrl:
    window["VUE_APP_KEYCLOAK_URL"] || process.env.VUE_APP_KEYCLOAK_URL,
  keycloakRealm:
    window["VUE_APP_KEYCLOAK_REALM"] || process.env.VUE_APP_KEYCLOAK_REALM,
  keycloakClientId:
    window["VUE_APP_KEYCLOAK_CLIENT_ID"] ||
    process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
  recaptchaKey:
    window["VUE_APP_RECAPTCHA_KEY"] || process.env.VUE_APP_RECAPTCHA_KEY,
  companyName:
    window["VUE_APP_COMPANY_NAME"] || process.env.VUE_APP_COMPANY_NAME,
};
